import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class WebcarService {

  constructor(private http: HttpClient) { }

/**
 * Invio email al client con allegato
 */
  sendEmailWithAttachment(mailTo: string, pdfBase64: any, vehcilePlate: string) {
    const emailSubject = `Carta d'identità del veicolo targato ${vehcilePlate}`;
    const attachmentName = `${vehcilePlate}.pdf`;
    const requestUrl: string = `${WEBCAR_URL}/SendEmailWithAttachment`;
    const emailModel = new SendEmailModel(mailTo, emailSubject, '', attachmentName, 'application/pdf', pdfBase64);
    const requestHeader: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/json', 'Authentication': JSON.stringify(new Authentication(USERNAME, PASSWORD)) });
    return this.http.post<any>(requestUrl, JSON.stringify(emailModel), { headers: requestHeader });
  }

  /**
   * Invio email al client
   * @param mailTo
   * @param vehcilePlate
   */
  sendEmail(mailTo: string, vehcilePlate: string) {
    const emailSubject = `Carta d'identità del veicolo targato ${vehcilePlate}`;
    const emailBody = `targa: ${vehcilePlate}`;
    let emailModel = new SendEmailModel(mailTo, emailSubject, emailBody);
    const requestUrl: string = `${WEBCAR_URL}/SendEmail`;
    let requestHeader: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/json', 'Authentication': JSON.stringify(new Authentication(USERNAME, PASSWORD)) });
    let requestBody: string = JSON.stringify(emailModel);
    return this.http.post<any>(requestUrl, requestBody, { headers: requestHeader });
  }
}


const WEBCAR_URL = "https://test.sdmain.com/cattolica/ws/api/videoperizia";
const USERNAME = "01950800027";
const PASSWORD = "01950800027";

class Authentication {
  username: string;
  password: string;

  constructor(username: string, password: string) {
    this.username = username;
    this.password = password;
  }
}

class SendEmailModel {
  mailTo: string;
  mailSubject: string;
  mailBody: string;
  attachmentName: string;
  attachmentContentType: string;
  attachmentBase64: string;

  constructor(mailTo: string, mailSubject: string, mailBody: string, attachmentName?: string, attachmentContentType?: string, attachmentBase64?: string) {
    this.mailTo = mailTo;
    this.mailSubject = mailSubject;
    this.mailBody = mailBody;
    this.attachmentName = attachmentName;
    this.attachmentContentType = attachmentContentType;
    this.attachmentBase64 = attachmentBase64;
  }
}
